import { FormControlLabel } from '@mui/material';
import Check from 'src/pages/Van/components/item/CheckIcon';

const info = [
  'Top Verified',
  'Top Communicator',
  'Profile Never Been Reported',
  'Active this month',
  'Speaks English - Native',
  'No unresolved issues',
  'Approved to drive',
  'Response rate - 100%',
  'Email address',
  'Response time - 30 minutes',
  'Phone number',
  'Text/Chat-Messenger'
];

export default function ExtrasHost() {
  return (
    <>
      {info.map((el, i) => (
        <FormControlLabel
          key={i}
          sx={{ cursor: 'default', gap: '5px' }}
          control={<Check className='hostModal__top__description__info__circleIcon' />}
          label={el}
        />
      ))}
    </>
  );
}
